import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

function getNoneInteractiveCls(selector) {
  const cls = [
    'data-selected',
    'data-outside',
    'data-start',
    'data-end',
    'data-disabled',
  ].map(i => `:not([${[i]}])`)
    .join('')
  return `&${cls}${selector}`
}

export default function initStyle() {
  return [
    registerThemeSpec('cmp.calendar', {
      wrapper: {
      },
      icon: {
        fill: 'mute',
        cursor: 'pointer',
        '&:hover': {
          fill: 'palette.mute.hover',
        },
      },
      header: {
        pt: 16,
        px: 20,
      },
      body: {
        pb: 8,
        mx: 20,
        pt: 12,
        width: 272,
        overflow: 'hidden',
      },
      title: {
        mb: 16,
        fontSize: '14px',
        lineHeight: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontWeight: 'medium',
      },
      row: {
        display: 'flex',
        fontSize: '14px',
        color: 'body',
        mb: 8,
        mx: '-4px',
      },
      cell: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'body',
      },
      square: {
        '&': {
          position: 'absolute',
          left: '50%',
          top: '50%',
          size: 24,
          content: '" "',
          zIndex: -1,
          borderRadius: 'circle',
          transform: 'translate(-50%, -50%)',
        },
      },
      matrixSquare: {
        '&': {
          position: 'absolute',
          left: '50%',
          top: '50%',
          height: 24,
          width: 'calc(100% - 16px)',
          content: '" "',
          zIndex: -1,
          borderRadius: '12px',
          transform: 'translate(-50%, -50%)',
        },
      },
      matrixCell: {
        'cmp.calendar': 'cell',
        position: 'relative',
        zIndex: 1,
        height: 32,
        '&[data-today]': {
          color: 'brand',
        },
        '&[data-selected]': {
          color: 'white',
          '&:before': {
            bg: 'brand',
            'cmp.calendar': 'matrixSquare',
          },
        },
        '&:not([data-selected]):hover': {
          cursor: 'pointer',
          '&:before': {
            bg: '#f2f7ff',
            'cmp.calendar': 'matrixSquare',
          },
        },
        '&[data-disabled]': {
          color: 'mute',
          bg: '#fbfbfb',
        },
        '&[data-disabled]:hover': {
          cursor: 'not-allowed',
          '&:before': {
            bg: '#fbfbfb',
          },
        },
      },
      dayCell: {
        height: 32,
        'cmp.calendar': 'cell',
        position: 'relative',
        zIndex: 1,
        '&[data-outside]': {
          color: 'mute',
          cursor: 'pointer',
        },
        '&[data-disabled]': {
          color: 'mute',
          cursor: 'not-allowed',
          bg: '#fbfbfb',
        },
        [getNoneInteractiveCls('[data-today]')]: {
          color: 'brand',
        },
        [`${getNoneInteractiveCls(':hover')}:not([data-range])`]: {
          cursor: 'pointer',
          '&:before': {
            bg: '#f2f7ff',
            'cmp.calendar': 'square',
          },
        },
        '&[data-range]': {
          bg: '#F2F7FF',
        },
        '&[data-start], &[data-end]': {
          cursor: 'pointer',
        },
        '&[data-start]:after': {
          left: 4,
          right: 0,
          borderTopLeftRadius: 'circle',
          borderBottomLeftRadius: 'circle',
        },
        '&[data-end]:after': {
          right: 4,
          left: 0,
          borderTopRightRadius: 'circle',
          borderBottomRightRadius: 'circle',
        },
        '&[data-start]:after, &[data-end]:after': {
          bg: '#F2F7FF',
          position: 'absolute',
          top: 0,
          bottom: 0,
          content: '" "',
          zIndex: -2,
        },
        '&[data-selected], &[data-start], &[data-end]': {
          color: 'white',
          '&:before': {
            bg: 'brand',
            'cmp.calendar': 'square',
          },
        },
      },
    }),
  ]
}
